
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDataWithToken } from '../../redux/payment-details-reducer.js';
import getQueryParam from '../../utils/getQueryParam.js';
import Error from '../components/error/error.jsx';
import numberWithCommas from '../../utils/numberWithCommas.js';
import splitPhone from '../../utils/splitPhone.js';
import Loader from '../components/loader/Loader.js';

/**
 * ConfirmationScreen component.
 *
 * @returns {JSX.Element} The rendered ConfirmationScreen component.
 */
function ConfirmationScreen() {
	const paymentDetails = useSelector(({ paymentDetails }) => paymentDetails);
	const isCardPayment = getQueryParam('paymentOption') === 'card';
	const confirmationNumber = getQueryParam('confirmationNumber');
	const dispatch = useDispatch();

	useEffect(() => {
		if (paymentDetails.paymentOption === 'card' || isCardPayment) {
			return;
		}

		dispatch(fetchDataWithToken());
	}, [null]);

	if (paymentDetails.errorsConf.length > 0) {
		return (
			<Error>
				{paymentDetails.errorsConf.map((element, index) => {
					if (typeof element.msg !== 'string' && !(element.msg instanceof String)) {
						element.msg = 'קרתה שגיאה לא צפויה במערכת. נא לפנות לשירות הלקוחות של גמא.';
					}

					return <div key={index}>{element.msg}</div>;
				})}
			</Error>
		);
	}

	if (confirmationNumber && !paymentDetails.confirmationNumber) {
		return (<div className='confirmation-screen'>
			<div className='confirmation-screen__success'>
				<div className='confirmation-screen__success__subtitle'>
					אישור תשלום - החיוב בוצע בהצלחה!
				</div>
				<div className='confirmation-screen__success__text'>
					מספר אסמכתא: <span> {confirmationNumber}</span>
				</div>
			</div>
		</div>);
	}

	return (paymentDetails.confirmationNumber) ? (
		<div className='confirmation-screen'>
			<div className='confirmation-screen__success'>
				<div className='confirmation-screen__success__subtitle'>
					אישור תשלום - החיוב בוצע בהצלחה!
				</div>
				<div className='confirmation-screen__success__text'>
					מספר אסמכתא: <span> {paymentDetails.confirmationNumber}</span>
				</div>
			</div>
			<hr />
			<div className='confirmation-screen__details'>
				<div className='confirmation-screen__details__title'>
					פרטי העסקה
				</div>
				<div className='confirmation-screen__details__subtitle'>
					בוצעה עסקה בסך: {numberWithCommas(paymentDetails.isOpenSum ? paymentDetails.paymentAmountOpen : paymentDetails.paymentAmount)} ש״ח </div>
				<div>
					<strong>מספר תשלומים:</strong>	 {paymentDetails.selectNumOfPayments}
				</div>
				{paymentDetails.Last4Digit && <div>
					<strong>בכרטיס:</strong>	 {paymentDetails.Last4Digit}
				</div>}
				{paymentDetails.CreditCompany && <div>
					<strong>חברת אשראי:</strong> {paymentDetails.CreditCompany}
				</div>}
				{paymentDetails.IdCC && <div>
					<strong>ת"ז בעל הכרטיס:</strong> {paymentDetails.IdCC}
				</div>}

				<div className='confirmation-screen__details__text'>
					<strong>תאריך:</strong> {paymentDetails.date}
				</div>
				<div className='confirmation-screen__details__text'>
					<strong>שם המוטב:</strong> {paymentDetails.sender}
				</div>
				<div className='confirmation-screen__details__text'>
					<strong>עבור:</strong> {paymentDetails.paymentFor}
				</div>
			</div>
			<hr className='d-md-none' />
			<div className='confirmation-screen__details'>
				<div style={{ marginTop: '38px' }} className='confirmation-screen__details__title'>
					פרטי הלקוח
				</div>
				<div className='confirmation-screen__details__text'>
					<strong>שם:</strong> {paymentDetails.isOpenContact ? paymentDetails.payerNameOpen + ' ' + (paymentDetails.payerLastNameOpen ?? '') : paymentDetails.payerName + ' ' + (paymentDetails.payerLastName ?? '')}
				</div>
				<div className='confirmation-screen__details__text'>
					<strong>טלפון:</strong> {paymentDetails.isOpenContact ? splitPhone(paymentDetails.payerPhoneOpen) : splitPhone(paymentDetails.payerPhone)}
				</div>
				<div className='confirmation-screen__details__text'>
					<strong>דוא״ל:</strong> {paymentDetails.isOpenContact ? paymentDetails.payerEmailOpen : paymentDetails.payerEmail}
				</div>
			</div>
		</div>
	) : (
		<Loader />
	);
}

export default ConfirmationScreen;
